import { render, staticRenderFns } from "./word.vue?vue&type=template&id=3e0feaec&scoped=true&"
import script from "./word.vue?vue&type=script&lang=js&"
export * from "./word.vue?vue&type=script&lang=js&"
import style0 from "./word.vue?vue&type=style&index=0&id=3e0feaec&scoped=true&lang=scss&"
import style1 from "./word.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0feaec",
  null
  
)

export default component.exports